module.exports = __webpack_public_path__ + "static/media/header_phone.9813c5cf.png";